import { render, staticRenderFns } from "./DetailBtns.vue?vue&type=template&id=cc1f913c&scoped=true&"
import script from "./DetailBtns.vue?vue&type=script&lang=js&"
export * from "./DetailBtns.vue?vue&type=script&lang=js&"
import style0 from "./DetailBtns.vue?vue&type=style&index=0&id=cc1f913c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc1f913c",
  null
  
)

export default component.exports